export enum BuyNumberRoutes {
  root = 'buy-number',
  steps = 'steps',

  chooseNumber = 'choose-number',
  assignNumber = 'assign-number',
  payment = 'payment',
}
